export class TipoBateria {
	_id: string;
	descripcion: string;
	estado: boolean;
	valorLimite: Number;
	duracionEstimada: Number;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/tipoBateria/tipoBateria.ts